var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body",attrs:{"id":"view"}},[_c('div',{staticClass:"padding"},[_c('user-company')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }